import {
  APPOINTMENT_RECEIVED,
  PATIENT_LIST_RECEIVED,
} from "../constants/types/appointmentType";

const initialState = {
  appointmentList: [],
};

export const appointmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case APPOINTMENT_RECEIVED: {
      return {
        ...state,
        appointmentList: action.payload,
      };
    }
    case PATIENT_LIST_RECEIVED:
      return {
        ...state,
        patientList: [
          { key: "Select a patient", value: "" },
          ...action.payload.map((element) => {
            return {
              key: element.name,
              value: element.user_id,
              email: element.email,
            };
          }),
        ],
      };
    default:
      return state;
  }
};
